/**
 * Minimal 404 for the app subdomain. Bare chrome; brand-styled.
 */
import React from "react";
import { Link } from "react-router-dom";
import { BRAND_LOGO_URL } from "@/lib/brandConfig";
import { MARKETING_BASE, marketingUrl } from "@/lib/marketingUrl";

export default function NotFound() {
    return (
        <div
            data-testid="not-found-page"
            style={{
                minHeight: "100vh",
                background: "#0F2747",
                color: "#EEF3F8",
                display: "flex",
                flexDirection: "column",
                fontFamily: "'Inter', system-ui, sans-serif",
            }}
        >
            <header style={{ padding: "20px 32px" }}>
                <a href={marketingUrl("/")} style={{ display: "inline-flex", alignItems: "center", gap: 12 }} data-testid="notfound-logo">
                    <img src={BRAND_LOGO_URL} alt="The Dream Forge Company" style={{ height: 40, width: "auto" }} />
                </a>
            </header>
            <main style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
                <div style={{ textAlign: "center", maxWidth: 520 }}>
                    <div style={{ fontSize: 11, letterSpacing: "0.3em", textTransform: "uppercase", opacity: 0.5 }}>404</div>
                    <h1 style={{
                        fontFamily: "'Cormorant Garamond', Georgia, serif",
                        fontSize: 48,
                        letterSpacing: "-0.01em",
                        marginTop: 12,
                        marginBottom: 12,
                        fontStyle: "italic",
                    }}>Page not found</h1>
                    <p style={{ fontSize: 14, opacity: 0.7, lineHeight: 1.5 }}>
                        The address you tried isn't part of the ForgeOS platform.
                    </p>
                    <div style={{ marginTop: 32, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                        <Link
                            to="/app/dashboard"
                            data-testid="notfound-cta-dashboard"
                            style={{
                                background: "#EEF3F8", color: "#0F2747",
                                padding: "10px 20px", textDecoration: "none",
                                border: "1px solid #DCEEFF",
                                letterSpacing: "0.08em", textTransform: "uppercase", fontSize: 11,
                            }}
                        >Return to Dashboard</Link>
                        <a
                            href={MARKETING_BASE}
                            data-testid="notfound-cta-marketing"
                            style={{
                                color: "#EEF3F8",
                                padding: "10px 20px",
                                textDecoration: "none",
                                border: "1px solid #DCEEFF",
                                letterSpacing: "0.08em", textTransform: "uppercase", fontSize: 11,
                            }}
                        >Visit thedreamforgecompany.com</a>
                    </div>
                </div>
            </main>
        </div>
    );
}
